import { createApi } from "@reduxjs/toolkit/query/react";
import CustomFetchBase from "../CustomFetchBase";

export const SubscriptionApi = createApi({
  reducerPath: "SubscriptionApi",
  baseQuery: CustomFetchBase,
  tagTypes: ["SUBSCRIPTIONAPI"],
  endpoints: (build) => ({
    getSubscriptions: build.query({
      query: ({ page = 1, limit = 10, userId = "", status = "" }) => ({
        url: `/subscription?page=${page}&limit=${limit}&userId=${userId}&status=${status}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["SUBSCRIPTIONAPI"],
    }),

    getSubscriptionById: build.query({
      query: ({ id }) => ({
        url: `/subscription/${id}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["SUBSCRIPTIONAPI"],
    }),
    getMySubscription: build.query({
      query: () => ({
        url: `/subscription/my-subscription`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["SUBSCRIPTIONAPI"],
    }),

    createSubscription: build.mutation({
      query: (data) => ({
        url: `/subscription`,
        method: "POST",
        body: data,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["SUBSCRIPTIONAPI"],
    }),

    updateSubscription: build.mutation({
      query: ({ id, data }) => ({
        url: `/subscription/${id}`,
        method: "PUT",
        body: data,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["SUBSCRIPTIONAPI"],
    }),

    cancelSubscription: build.mutation({
      query: ({ id, cancellationReason = "" }) => ({
        url: `/subscription/${id}/cancel`,
        method: "PATCH",
        body: { cancellationReason },
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["SUBSCRIPTIONAPI"],
    }),

    deleteSubscription: build.mutation({
      query: ({ id }) => ({
        url: `/subscription/${id}`,
        method: "DELETE",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["SUBSCRIPTIONAPI"],
    }),
  }),
});

export const {
  useGetSubscriptionsQuery,
  useGetSubscriptionByIdQuery,
  useCreateSubscriptionMutation,
  useUpdateSubscriptionMutation,
  useCancelSubscriptionMutation,
  useDeleteSubscriptionMutation,
  useLazyGetSubscriptionsQuery,
  useLazyGetSubscriptionByIdQuery,
  useGetMySubscriptionQuery,
} = SubscriptionApi;
